export default __webpack_public_path__ + "static/media/base-apparel.aafca3a1.png";